import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const archimindUiPlugin = createPlugin({
  id: 'archimind-ui',
  routes: {
    root: rootRouteRef,
  },
});

export const ArchimindUploadPage = archimindUiPlugin.provide(
  createRoutableExtension({
    name: 'ArchimindUploadPage',
    component: () =>
      import('./components/ArchimindUploadComponent').then(m => m.ArchimindUploadComponent),
    mountPoint: rootRouteRef,
  }),
);

export const ArchimindLaunchPage = archimindUiPlugin.provide(
  createRoutableExtension({
    name: 'ArchimindLaunchPage',
    component: () =>
      import('./components/ArchimindLaunchComponent').then(m => m.ArchimindLaunchComponent),
    mountPoint: rootRouteRef,
  }),
);
